import extendToken from './extendToken';
import getFacebookLinkedAccounts from './getFacebookLinkedAccounts';
import getInstagramLinkedAccounts from './getInstagramLinkedAccounts';
import refreshFacebookPages from './refreshFacebookPages';
import refreshInstagramAccounts from './refreshInstagramAccounts';
import saveFbPages from './saveFbPages';
import saveIgAccounts from './saveIgAccounts';
import removeIgAccount from './removeIgAccount';
import removeFbPage from './removeFbPage';
import getClientRsps from './getClientRsps';
import getClientOnboarding from './getClientOnboarding';
import updatePlacementSponsorAssociation from './updatePlacementSponsorAssociation';
import dissociateSponsor from './dissociateSponsor';
import deactivateSponsor from './deactivateSponsor';
import addPlacementImage from './addPlacementImage';
import removePlacementImage from './removePlacementImage';
import addPlacement from './addPlacement';
import updatePlacementBoundingBox from './updatePlacementBoundingBox';

import combineActions from '../../utils/combineActions';

export default combineActions({
    extendToken,
    getFacebookLinkedAccounts,
    getInstagramLinkedAccounts,
    refreshFacebookPages,
    refreshInstagramAccounts,
    saveFbPages,
    saveIgAccounts,
    removeIgAccount,
    removeFbPage,
    getClientRsps,
    getClientOnboarding,
    updatePlacementSponsorAssociation,
    dissociateSponsor,
    deactivateSponsor,
    addPlacementImage,
    removePlacementImage,
    addPlacement,
    updatePlacementBoundingBox,
    // more actions here
});
